export default "/Frontend/dist/doc-required.84724ee12538f1aa5db78a7c93068325.svg";